export default "__VITE_ASSET__Czml_ckh__"